// import RepositoryFactory from "@/apis";
// const respitecare = RepositoryFactory.respitecare;
import respitecare from "../../apis/respitecare";

export default {
  createbooking({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await respitecare.createbooking(payload);
        commit("User_volbooking", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deletebooking({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.deletebooking(payload);

        // Update user details
        commit("DELETE_Service", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editbooking({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.editbooking(payload);

        // Update user details
        // commit("SELECT_Service", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getbooking({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.getbooking(payload);

        commit("GETALL_Service_Card", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_upcomingbooking({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_upcomingbooking(payload);

        commit("GETALL_Upcomingbooking", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_completedbooking({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_completedbooking(payload);

        commit("GETALL_Completedbooking", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_allbookingcounts({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_allbookingcounts(payload);
        // console.log(data.data[0]);
        commit("GETALL_Bookingcounts", data.data[0]);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_allbooking({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_allbooking(payload);

        // console.log("datadata", data);
        if (data.data.hasOwnProperty("result")) {
          commit("GETALL_booking", data.data);
        } else {
          commit("GETALL_booking", data.data.reverse());
        }
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getvolunteerbooking({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.getvolunteerbooking(payload);

        commit("GET_volunteerbooking", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  //requirement apis
  createrequirement({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await respitecare.createrequirement(payload);
        // commit("ADD_BOOKING", payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleterequirement({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.deleterequirement(payload);

        // Update user details
        commit("DELETE_Partner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editrequirement({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.editrequirement(payload);

        // Update user details
        // commit("SELECT_Partner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getrequirement({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.getrequirement(payload);

        commit("GETALL_Partner", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  get_allrequirement({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_allrequirement(payload);

        commit("GETALL_Requirement", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  //review apis
  createreview({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await respitecare.createreview(payload);
        commit("ADD_review", payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },
  deletereview({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.deletereview(payload);

        // Update user details
        commit("DELETE_Workshop", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editreview({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.editreview(payload);

        // Update user details
        commit("SELECT_Workshop", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getreview({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.getreview(payload);

        commit("GETALL_Workshop", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_allreview({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_allreview(payload);

        commit("GET_allreviewbyid", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  //volunteer
  createvolunteer({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await respitecare.createvolunteer(payload);
        // commit("ADD_BOOKING", payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },

  addAdminVolunteer({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await respitecare.addAdminVolunteer(payload);
        // commit("ADD_BOOKING", payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deletevolunteer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.deletevolunteer(payload);

        // Update user details
        commit("DELETE_Banner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editvolunteer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.editvolunteer(payload);

        // Update user details
        // commit("SELECT_Banner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  update_statusvolunteer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.update_status_volunteer(payload);

        // Update user details
        // commit("SELECT_Banner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_volunteerbylocation({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_volunteerbylocation(payload);

        commit("GET_volunteerbylocation", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getVolunteerByService({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.getVolunteerByService(payload);

        commit("GET_VOLUNTEER_BY_SERVICE", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getVolunteerByDesignation({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.getVolunteerByDesignation(payload);

        commit("GET_VOLUNTEER_BY_DESIGNATION", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  get_volunteerbyid({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_volunteerbyid(payload);

        commit("GET_volunteerbyid", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_all_volunteer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_all_volunteer(payload);

        commit("GETALL_Banner", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_volunteer_by_admin({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_volunteer_by_admin(payload);

        commit("GET_Volunteerbyadmin", data.data.reverse());
        // commit("GETALL_Banner", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_all_count({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_all_count(payload);

        commit("GET_Allcount", data.data);
        // commit("GETALL_Banner", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  pausevolunteer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.pausevolunteer(payload);

        // Update user details
        commit("SELECT_Banner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_volunteerbyuserid({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await respitecare.get_volunteerbyuserid(payload);
        // console.log(data.data);
        commit("GET_volunteerbyuserid", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  //email
  email_bookingsession({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await respitecare.email_bookingsession(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  email_acceptvolunteer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await respitecare.email_acceptvolunteer(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  email_rejectvolunteer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await respitecare.email_rejectvolunteer(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  email_postreq({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await respitecare.email_postreq(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  email_becomevol({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await respitecare.email_becomevol(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  email_booking({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.email_booking(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  add_location({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.add_location(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_all_location({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_all_location(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_all_location_name({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_all_location_name(payload);
        commit("GET_AllLocationName", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_location_by_name({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.get_location_by_name(payload);
        commit("GET_LocationByName", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  delete_location({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.delete_location(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  edit_location({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.edit_location(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////
  //////////////WITHDRAWAL//////////////////////
  ///////////////////////////////////////////////////

  createWithdrawal({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await respitecare.createWithdrawal(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteWithdrawal({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.deleteWithdrawal(payload);

        // Update user details
        commit("DELETE_Workshop", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  editWithdrawal({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.editWithdrawal(payload);

        // Update user details
        commit("SELECT_Workshop", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getWithdrawal({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.getWithdrawal(payload);

        commit("GET_WITHDRAWAL", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAllWithdrawal({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await respitecare.getAllWithdrawal(payload);

        commit("GET_ALL_WITHDRAWALS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
